/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationDurations200ResponseOneOf1ValuesInner
 */
export interface GetReservationDurations200ResponseOneOf1ValuesInner {
    /**
     * 
     * @type {string}
     * @memberof GetReservationDurations200ResponseOneOf1ValuesInner
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof GetReservationDurations200ResponseOneOf1ValuesInner
     */
    value: number;
}

/**
 * Check if a given object implements the GetReservationDurations200ResponseOneOf1ValuesInner interface.
 */
export function instanceOfGetReservationDurations200ResponseOneOf1ValuesInner(value: object): value is GetReservationDurations200ResponseOneOf1ValuesInner {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function GetReservationDurations200ResponseOneOf1ValuesInnerFromJSON(json: any): GetReservationDurations200ResponseOneOf1ValuesInner {
    return GetReservationDurations200ResponseOneOf1ValuesInnerFromJSONTyped(json, false);
}

export function GetReservationDurations200ResponseOneOf1ValuesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationDurations200ResponseOneOf1ValuesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'value': json['value'],
    };
}

export function GetReservationDurations200ResponseOneOf1ValuesInnerToJSON(json: any): GetReservationDurations200ResponseOneOf1ValuesInner {
    return GetReservationDurations200ResponseOneOf1ValuesInnerToJSONTyped(json, false);
}

export function GetReservationDurations200ResponseOneOf1ValuesInnerToJSONTyped(value?: GetReservationDurations200ResponseOneOf1ValuesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
    };
}

